export const MAX_PDFS = 5;
export const MAX_IMAGES = 10;
export const MAX_FILE_MB = 8;
export const MAX_TOTAL_MB = 20;
export const MAX_CONCURRENT = 3;
export const TIMEOUT_MS = 120_000;
export const RETRY_MAX = 1;
export const PRICE_TOLERANCE_RATIO = 0.1;
export const COOLDOWN_KEY = 'smart_menu_last_attempt';
export const COOLDOWN_MS = 60 * 60 * 1000;
export const ACCEPTED_PDF_MIME = 'application/pdf';
export const ACCEPTED_IMAGE_MIMES = ['image/jpeg', 'image/png', 'image/webp', 'image/heic'] as const;
